/* LD landing — JS mínimo, sin librerías */
(function(){
  'use strict';
  document.documentElement.classList.add('ld-js');
  if (document.querySelector('.ld')) document.body.classList.add('ld-page');

  /* Galería */
  document.querySelectorAll('[data-ld-gallery]').forEach(function(gal){
    var track = gal.querySelector('.ld-gal__track');
    var slides = track ? track.children : [];
    var count = gal.querySelector('.ld-gal__count');
    var thumbs = gal.querySelectorAll('.ld-gal__thumbs button');
    if (!track || slides.length < 2) return;
    function idx(){ return Math.round(track.scrollLeft / track.clientWidth); }
    function go(i){ i = Math.max(0, Math.min(slides.length - 1, i)); track.scrollTo({left: i * track.clientWidth, behavior: 'smooth'}); }
    function update(){ var i = idx(); if (count) count.textContent = (i + 1) + ' / ' + slides.length; thumbs.forEach(function(t, n){ t.setAttribute('aria-current', n === i ? 'true' : 'false'); }); }
    var tmr; track.addEventListener('scroll', function(){ clearTimeout(tmr); tmr = setTimeout(update, 60); }, {passive: true});
    var prev = gal.querySelector('.ld-gal__nav--prev'), next = gal.querySelector('.ld-gal__nav--next');
    if (prev) prev.addEventListener('click', function(){ go(idx() - 1); });
    if (next) next.addEventListener('click', function(){ go(idx() + 1); });
    thumbs.forEach(function(t, n){ t.addEventListener('click', function(){ go(n); }); });
    update();
  });

  /* Ofertas → precio del sticky + evento para analytics */
  function currentOffer(){ return document.querySelector('.ld-offer input:checked'); }
  function syncSticky(){
    var o = currentOffer(); var p = document.querySelector('[data-ld-sticky-price]'); var l = document.querySelector('[data-ld-sticky-label]');
    if (!o) return;
    if (p && o.dataset.price) p.textContent = o.dataset.price;
    if (l && o.dataset.title) l.textContent = o.dataset.title;
  }
  document.addEventListener('change', function(e){
    if (!e.target.matches || !e.target.matches('.ld-offer input')) return;
    syncSticky();
    var d = e.target.dataset;
    document.dispatchEvent(new CustomEvent('ld:select-offer', {detail: {quantity: Number(e.target.value), title: d.title || '', price: d.priceNum ? Number(d.priceNum) : null}}));
  });
  syncSticky();

  /* Botón principal: Releasit si existe; si no, el botón nativo */
  function rsiButton(){ var f = document.querySelector('.ld-form'); return f ? f.querySelector('._rsi-buy-now-button') || document.querySelector('._rsi-buy-now-button-product') : null; }
  function buy(){
    var r = rsiButton();
    if (r) { r.click(); return; }
    var nat = document.querySelector('.ld-form [data-ld-native]');
    if (nat && !nat.disabled) { setTimeout(buy, 250); return; }
    var box = document.querySelector('.ld-buy'); if (box) box.scrollIntoView({behavior: 'smooth', block: 'center'});
  }
  document.querySelectorAll('[data-ld-buy]').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); buy(); }); });

  /* Releasit pone estilos en línea; aquí se igualan al botón de la landing (solo en esta página) */
  function styleRsi(b){
    var cs = getComputedStyle(document.documentElement);
    var bg = cs.getPropertyValue('--ld-cta').trim(), fg = cs.getPropertyValue('--ld-cta-text').trim(), dk = cs.getPropertyValue('--ld-cta-dark').trim();
    if (!bg) return;
    var apply = function(){
      b.style.setProperty('background', bg, 'important');
      b.style.setProperty('color', fg, 'important');
      b.style.setProperty('border', '0', 'important');
      b.style.setProperty('border-radius', '12px', 'important');
      b.style.setProperty('box-shadow', '0 4px 0 ' + dk, 'important');
      b.style.setProperty('min-height', '62px', 'important');
      b.querySelectorAll('svg').forEach(function(s){ s.setAttribute('fill', fg); });
    };
    apply();
    if ('MutationObserver' in window) new MutationObserver(function(m){ if (b.style.background.indexOf(bg) === -1) apply(); }).observe(b, {attributes: true, attributeFilter: ['style']});
  }

  /* Al abrir el formulario de Releasit, marcar dentro el mismo paquete que eligió el cliente en la landing.
     (Releasit solo lee la cantidad la primera vez que se abre; esto lo mantiene sincronizado.) */
  function syncRsi(){
    var o = currentOffer(); var box = document.querySelector('.ld-form'); if (!o || !box) return;
    var pid = box.dataset.productId, qty = Number(o.value);
    var list = (window._RSI_COD_FORM_QUANTIY_OFFERS || []).filter(function(x){ return x.isActive && x.pIds && x.pIds.indexOf(String(pid)) > -1; });
    if (!list.length) return;
    var match = (list[0].offers || []).filter(function(x){ return Number(x.qty) === qty; })[0];
    if (!match) { if (window.console) console.warn('[LD] La oferta de ' + qty + ' piezas no existe en Releasit. Revisa que las cantidades coincidan.'); return; }
    var el = document.querySelector('._rsi-quantity-offers-offer-container[data-offer-pos="' + match.pos + '"] ._rsi-quantity-offers-offer');
    if (el) el.click();
  }
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('._rsi-buy-now-button');
    if (!b || b.closest('._rsi-modal-container')) return;
    setTimeout(syncRsi, 450); setTimeout(syncRsi, 1200);
  }, true);

  /* Si Releasit no aparece, mostrar el botón nativo; si aparece, ocultarlo */
  var tries = 0;
  (function watchRsi(){
    var nat = document.querySelector('.ld-form [data-ld-native]');
    if (!nat) return;
    var rb = rsiButton();
    if (rb) { nat.hidden = true; styleRsi(rb); return; }
    nat.hidden = true;
    if (++tries < 40) setTimeout(watchRsi, 250);
  })();

  /* Sticky: aparece cuando la caja de compra sale de pantalla */
  var sticky = document.querySelector('.ld-sticky'); var anchor = document.querySelector('.ld-form');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    var past = false;
    new IntersectionObserver(function(ent){
      var e = ent[0]; past = !e.isIntersecting && e.boundingClientRect.top < 0;
      sticky.classList.toggle('is-on', past); document.body.classList.toggle('ld-sticky-on', past);
    }, {threshold: 0}).observe(anchor);
  }

  /* Fechas de envío (días hábiles, sin domingo) */
  function addDays(d, n){ var r = new Date(d); var c = 0; while (c < n) { r.setDate(r.getDate() + 1); if (r.getDay() !== 0) c++; } return r; }
  var M = ['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];
  function f(d){ return d.getDate() + ' ' + M[d.getMonth()]; }
  function rng(a, b){ return a.getMonth() === b.getMonth() ? a.getDate() + '–' + b.getDate() + ' ' + M[b.getMonth()] : f(a) + ' – ' + f(b); }
  document.querySelectorAll('[data-ld-ship]').forEach(function(box){
    var now = new Date();
    var a = parseInt(box.dataset.shipMin, 10) || 0, b = parseInt(box.dataset.shipMax, 10) || a, dmin = parseInt(box.dataset.delMin, 10) || 0, dmax = parseInt(box.dataset.delMax, 10) || dmin;
    var set = function(sel, txt){ var el = box.querySelector(sel); if (el) el.textContent = txt; };
    set('[data-ship-0]', f(now));
    set('[data-ship-1]', a === b ? f(addDays(now, a)) : rng(addDays(now, a), addDays(now, b)));
    set('[data-ship-2]', dmin === dmax ? f(addDays(now, dmin)) : rng(addDays(now, dmin), addDays(now, dmax)));
  });

  /* Videos: cargan y se reproducen solo al verse */
  var vids = document.querySelectorAll('video[data-ld-lazy]');
  if (vids.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(ents){
      ents.forEach(function(e){
        var v = e.target;
        if (e.isIntersecting) {
          if (!v.dataset.loaded) { v.querySelectorAll('source[data-src]').forEach(function(s){ s.src = s.dataset.src; }); v.load(); v.dataset.loaded = '1'; }
          var p = v.play(); if (p && p.catch) p.catch(function(){});
        } else { v.pause(); }
      });
    }, {threshold: 0.4});
    vids.forEach(function(v){ io.observe(v); });
  }
})();
